<span class="flex align-items-center w-full h-full">
  <i [class]="iconClass()"></i>
</span>
